/**
 * Class for team sections.
 *
 * @class      Team (name)
 */
export class Team
{
	/**
	 * Adds necessary event listeners.
	 */
	static addListeners()
	{
		// Wait for DOMContentLoaded
		$( document ).ready(
			function()
			{
				$( '.team__item' ).on(
					'click',
					function( e )
					{
						e.stopPropagation();

						if ( ! $( this ).children( '.team__contact-info' ).hasClass( 'open' ) )
						{
							$( this ).children( '.team__contact-info' ).addClass( 'open' );
						}
					}
				);


				$( '.team__bg-info-close-btn' ).on(
					'click',
					function( e )
					{
						e.stopPropagation();

						if ( $( this ).parent( '.team__contact-info' ).hasClass( 'open' ) )
						{
							$( this ).parent( '.team__contact-info' ).removeClass( 'open' );
						}
					}
				);
			}
		);
	}
}



// WEBPACK FOOTER //
// ../wp-content/themes/wisesite/assets/js/plugins/modules/team/team.js